var _defs, _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _view, _view2, _view3, _view4, _view5, _view6, _view7, _view8, _view9, _view10, _view11, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "play",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "play"), /*#__PURE__*/React.createElement("path", {
    d: "M7.50632 3.14928C6.1753 2.29363 4.4248 3.24931 4.4248 4.83164V19.1683C4.4248 20.7506 6.1753 21.7063 7.50632 20.8507L18.6571 13.6823C19.8817 12.8951 19.8817 11.1049 18.6571 10.3176L7.50632 3.14928Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "pause",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "pause"), /*#__PURE__*/React.createElement("path", {
    d: "M6 3C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H9C10.1046 21 11 20.1046 11 19V5C11 3.89543 10.1046 3 9 3H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3C13.8954 3 13 3.89543 13 5V19C13 20.1046 13.8954 21 15 21H18C19.1046 21 20 20.1046 20 19V5C20 3.89543 19.1046 3 18 3H15Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "stop",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "stop"), /*#__PURE__*/React.createElement("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "backward-end",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "backward-end"), /*#__PURE__*/React.createElement("path", {
    d: "M17.8906 4.20444C19.2197 3.31836 21 4.27115 21 5.86854V18.1315C21 19.7289 19.2197 20.6817 17.8906 19.7956L8.69337 13.6641C7.50591 12.8725 7.50591 11.1276 8.69337 10.3359L17.8906 4.20444Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.5C5.05228 3.5 5.5 3.94772 5.5 4.5V19.5C5.5 20.0523 5.05228 20.5 4.5 20.5H3.5C2.94772 20.5 2.5 20.0523 2.5 19.5V4.5C2.5 3.94772 2.94772 3.5 3.5 3.5H4.5Z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "backward",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "backward"), /*#__PURE__*/React.createElement("path", {
    d: "M3.42091 4.83828C2.43562 4.07194 1 4.77409 1 6.02231V17.9777C1 19.2259 2.43562 19.928 3.42091 19.1617L11.6139 12.7893C11.8575 12.5999 12 12.3086 12 12V17.9777C12 19.2259 13.4356 19.928 14.4209 19.1617L22.6139 12.7893C22.8575 12.5999 23 12.3086 23 12C23 11.6914 22.8575 11.4001 22.6139 11.2106L14.4209 4.83828C13.4356 4.07194 12 4.77409 12 6.02231V12C12 11.6914 11.8575 11.4001 11.6139 11.2106L3.42091 4.83828Z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "forward",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "forward"), /*#__PURE__*/React.createElement("path", {
    d: "M3.42091 4.83828C2.43562 4.07194 1 4.77409 1 6.02231V17.9777C1 19.2259 2.43562 19.928 3.42091 19.1617L11.6139 12.7893C11.8575 12.5999 12 12.3086 12 12V17.9777C12 19.2259 13.4356 19.928 14.4209 19.1617L22.6139 12.7893C22.8575 12.5999 23 12.3086 23 12C23 11.6914 22.8575 11.4001 22.6139 11.2106L14.4209 4.83828C13.4356 4.07194 12 4.77409 12 6.02231V12C12 11.6914 11.8575 11.4001 11.6139 11.2106L3.42091 4.83828Z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "forward-end",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "forward-end"), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 4.5C21.5 3.94772 21.0523 3.5 20.5 3.5H19.5C18.9477 3.5 18.5 3.94772 18.5 4.5V19.5C18.5 20.0523 18.9477 20.5 19.5 20.5H20.5C21.0523 20.5 21.5 20.0523 21.5 19.5V4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5.86854C3 4.27115 4.78029 3.31836 6.1094 4.20444L15.3066 10.3359C16.4941 11.1276 16.4941 12.8725 15.3066 13.6641L6.1094 19.7956C4.78029 20.6817 3 19.7289 3 18.1315V5.86854Z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 97.75 97.75"
  }, /*#__PURE__*/React.createElement("title", null, "facebook"), /*#__PURE__*/React.createElement("path", {
    d: "M48.875,0C21.882,0,0,21.882,0,48.875S21.882,97.75,48.875,97.75S97.75,75.868,97.75,48.875S75.868,0,48.875,0z M67.521,24.89l-6.76,0.003c-5.301,0-6.326,2.519-6.326,6.215v8.15h12.641L67.07,52.023H54.436v32.758H41.251V52.023H30.229V39.258 h11.022v-9.414c0-10.925,6.675-16.875,16.42-16.875l9.851,0.015V24.89L67.521,24.89z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "youtube",
    viewBox: "0 0 97.75 97.75"
  }, /*#__PURE__*/React.createElement("title", null, "youtube"), /*#__PURE__*/React.createElement("polygon", {
    points: "25.676,52.482 29.551,52.482 29.551,73.455 33.217,73.455 33.217,52.482 37.164,52.482 37.164,49.047 25.676,49.047  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.674,55.046c-1.212,0-2.343,0.662-3.406,1.972v-7.972h-3.295v24.409h3.295v-1.762c1.103,1.361,2.233,2.013,3.406,2.013 c1.311,0,2.193-0.69,2.633-2.044c0.221-0.771,0.334-1.982,0.334-3.665v-7.242c0-1.722-0.113-2.924-0.334-3.655 C58.868,55.736,57.984,55.046,56.674,55.046z M56.344,68.255c0,1.644-0.482,2.454-1.434,2.454c-0.541,0-1.092-0.259-1.643-0.811 V58.814c0.551-0.545,1.102-0.803,1.643-0.803c0.951,0,1.434,0.842,1.434,2.482V68.255z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.824,69.167c-0.731,1.033-1.422,1.542-2.084,1.542c-0.44,0-0.691-0.259-0.771-0.771c-0.03-0.106-0.03-0.508-0.03-1.28 v-13.39h-3.296v14.379c0,1.285,0.111,2.153,0.291,2.705c0.331,0.922,1.063,1.354,2.123,1.354c1.213,0,2.457-0.732,3.767-2.234 v1.984h3.298V55.268h-3.298V69.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.653,38.466c1.073,0,1.588-0.851,1.588-2.551v-7.731c0-1.701-0.515-2.548-1.588-2.548c-1.074,0-1.59,0.848-1.59,2.548 v7.731C45.063,37.616,45.579,38.466,46.653,38.466z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.875,0C21.882,0,0,21.882,0,48.875S21.882,97.75,48.875,97.75S97.75,75.868,97.75,48.875S75.868,0,48.875,0z  M54.311,22.86h3.321v13.532c0,0.781,0,1.186,0.04,1.295c0.073,0.516,0.335,0.78,0.781,0.78c0.666,0,1.365-0.516,2.104-1.559 V22.86h3.33v18.379h-3.33v-2.004c-1.326,1.52-2.59,2.257-3.805,2.257c-1.072,0-1.812-0.435-2.146-1.365 c-0.184-0.557-0.295-1.436-0.295-2.733V22.86L54.311,22.86z M41.733,28.853c0-1.965,0.334-3.401,1.042-4.33 c0.921-1.257,2.218-1.885,3.878-1.885c1.668,0,2.964,0.628,3.885,1.885c0.698,0.928,1.032,2.365,1.032,4.33v6.436 c0,1.954-0.334,3.403-1.032,4.322c-0.921,1.254-2.217,1.881-3.885,1.881c-1.66,0-2.957-0.627-3.878-1.881 c-0.708-0.919-1.042-2.369-1.042-4.322V28.853z M32.827,16.576l2.622,9.685l2.519-9.685h3.735L37.26,31.251v9.989h-3.692v-9.989 c-0.335-1.77-1.074-4.363-2.259-7.803c-0.778-2.289-1.589-4.585-2.367-6.872H32.827z M75.186,75.061 c-0.668,2.899-3.039,5.039-5.894,5.358c-6.763,0.755-13.604,0.759-20.42,0.755c-6.813,0.004-13.658,0-20.419-0.755 c-2.855-0.319-5.227-2.458-5.893-5.358c-0.951-4.129-0.951-8.638-0.951-12.89s0.012-8.76,0.962-12.89 c0.667-2.9,3.037-5.04,5.892-5.358c6.762-0.755,13.606-0.759,20.421-0.755c6.813-0.004,13.657,0,20.419,0.755 c2.855,0.319,5.227,2.458,5.896,5.358c0.948,4.13,0.942,8.638,0.942,12.89S76.137,70.932,75.186,75.061z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.17,55.046c-1.686,0-2.995,0.619-3.947,1.864c-0.699,0.92-1.018,2.342-1.018,4.285v6.371 c0,1.933,0.357,3.365,1.059,4.276c0.951,1.242,2.264,1.863,3.988,1.863c1.721,0,3.072-0.651,3.984-1.972 c0.4-0.584,0.66-1.245,0.77-1.975c0.031-0.33,0.07-1.061,0.07-2.124v-0.479h-3.361c0,1.32-0.043,2.053-0.072,2.232 c-0.188,0.881-0.662,1.321-1.473,1.321c-1.132,0-1.686-0.84-1.686-2.522v-3.226h6.592v-3.767c0-1.943-0.329-3.365-1.02-4.285 C70.135,55.666,68.824,55.046,67.17,55.046z M68.782,62.218h-3.296v-1.683c0-1.682,0.553-2.523,1.654-2.523 c1.09,0,1.642,0.842,1.642,2.523V62.218z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "mail",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("title", null, "mail"), /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M412,353.5 c0,20.193-16.37,36.562-36.562,36.562H136.562c-20.193,0-36.562-16.37-36.562-36.562v-195c0-20.193,16.37-36.562,36.562-36.562 h238.875c20.193,0,36.562,16.37,36.562,36.562V353.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.463,166.703L256,212.004l-78.463-45.301c-8.744-5.048-19.924-2.052-24.973,6.691 c-5.048,8.744-2.052,19.924,6.691,24.973l87.604,50.578l0.001-0.002c2.777,1.6,5.936,2.443,9.139,2.448 c3.204-0.004,6.363-0.848,9.139-2.448l0.001,0.002l87.604-50.578c8.744-5.048,11.74-16.229,6.691-24.973 C354.388,164.651,343.207,161.655,334.463,166.703z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 83 40.1"
  }, /*#__PURE__*/React.createElement("title", null, "logo"), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1,0.5L22.1,0.5c-1.6,0.6-2.8,1.6-3.6,2.8l0,0L5.1,22.4l0,0l-3.7,5.3l0,0C0.6,29,0,30.4,0,32.1v0 c-0.1,5.6,5.4,9.4,10.6,7.5h0c1.6-0.6,2.8-1.6,3.6-2.8l0,0l13.4-19.1l0,0l3.7-5.3l0,0c0.9-1.2,1.4-2.7,1.4-4.4v0 C32.9,2.4,27.3-1.5,22.1,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7,0.5L27.7,0.5c1.6,0.6,2.8,1.6,3.6,2.8l0,0l13.4,19.1l0,0l3.7,5.3l0,0c0.9,1.2,1.4,2.7,1.4,4.4v0 c0.1,5.6-5.4,9.4-10.6,7.5h0c-1.6-0.6-2.8-1.6-3.6-2.8l0,0L22.2,17.7l0,0l-3.7-5.3l0,0c-0.9-1.2-1.4-2.7-1.4-4.4v0 C17,2.4,22.6-1.5,27.7,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,0.5L53,0.5c1.6,0.6,2.8,1.6,3.6,2.8l0,0L70,22.4l0,0l3.7,5.3l0,0c0.9,1.2,1.4,2.7,1.4,4.4v0 c0.1,5.6-5.4,9.4-10.6,7.5h0c-1.6-0.6-2.8-1.6-3.6-2.8l0,0L47.5,17.7l0,0l-3.7-5.3l0,0c-0.9-1.2-1.4-2.7-1.4-4.4v0 C42.2,2.4,47.8-1.5,53,0.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.6,12.2L68.6,12.2c3.1,4.6,9.9,4.6,13,0l0,0C85.1,7,81.4,0,75.1,0h0C68.8,0,65.1,7,68.6,12.2z",
    fill: "#1bf2a3"
  }))), _view || (_view = /*#__PURE__*/React.createElement("view", {
    id: "play",
    viewBox: "0 0 24 24"
  })), _view2 || (_view2 = /*#__PURE__*/React.createElement("view", {
    id: "pause",
    viewBox: "0 24 24 24"
  })), _view3 || (_view3 = /*#__PURE__*/React.createElement("view", {
    id: "stop",
    viewBox: "0 48 24 24"
  })), _view4 || (_view4 = /*#__PURE__*/React.createElement("view", {
    id: "backward-end",
    viewBox: "0 72 24 24"
  })), _view5 || (_view5 = /*#__PURE__*/React.createElement("view", {
    id: "backward",
    viewBox: "0 96 24 24"
  })), _view6 || (_view6 = /*#__PURE__*/React.createElement("view", {
    id: "forward",
    viewBox: "0 120 24 24"
  })), _view7 || (_view7 = /*#__PURE__*/React.createElement("view", {
    id: "forward-end",
    viewBox: "0 144 24 24"
  })), _view8 || (_view8 = /*#__PURE__*/React.createElement("view", {
    id: "facebook",
    viewBox: "0 168 24 24"
  })), _view9 || (_view9 = /*#__PURE__*/React.createElement("view", {
    id: "youtube",
    viewBox: "0 192 24 24"
  })), _view10 || (_view10 = /*#__PURE__*/React.createElement("view", {
    id: "mail",
    viewBox: "0 216 24 24"
  })), _view11 || (_view11 = /*#__PURE__*/React.createElement("view", {
    id: "logo",
    viewBox: "0 230 24 24"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#play",
    width: 24,
    height: 24,
    x: 0,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pause",
    width: 24,
    height: 24,
    x: 0,
    y: 24
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stop",
    width: 24,
    height: 24,
    x: 0,
    y: 48
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#backward-end",
    width: 24,
    height: 24,
    x: 0,
    y: 72
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#backward",
    width: 24,
    height: 24,
    x: 0,
    y: 96
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#forward",
    width: 24,
    height: 24,
    x: 0,
    y: 120
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#forward-end",
    width: 24,
    height: 24,
    x: 0,
    y: 144
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#facebook",
    width: 24,
    height: 24,
    x: 0,
    y: 168
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#youtube",
    width: 24,
    height: 24,
    x: 0,
    y: 192
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mail",
    width: 24,
    height: 24,
    x: 0,
    y: 216
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo",
    width: 24,
    height: 24,
    x: 0,
    y: 230
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.7fadc3e06720a33fe216f1a478198ce1.svg";
export { ForwardRef as ReactComponent };